export default {
  REPLACE_PAGE: 'replace',
  COPY_PAGE: 'copy',
};
